import api from './api';

export type VisibilityView = 'destination' | 'origin' | 'returns';

export interface VisibilityRow {
  location_code: number;
  location_name: string;
  nd_total: number;
  nd_triaxle: number;
  nd_swing: number;
  nd_reg: number;
  nd_hot: number;
  nd_haz: number;
  d_driver: number;
  d_no_og: number;
  d_no_ch: number;
}

export interface VisibilityMove {
  pronumber: string;
  legnum: number;
  driver: string;
  isMule?: boolean;
  movetype: string;
  triaxle: string;
  swing: string;
  hot: string;
  hazmat: string;
  container: string;
  chassisid: string;
  outgatedatetime: number;
  location_name: string;
  appt_date: string;
}

export type VisibilityBucket =
  | 'nd_total' | 'nd_triaxle' | 'nd_swing' | 'nd_reg' | 'nd_hot' | 'nd_haz'
  | 'd_driver' | 'd_no_og' | 'd_no_ch';

interface ListResponse<T> { data: T[]; count: number; }

export interface VisibilityFilters {
  order_dispatchers?: string[];
  regions?: string[];
  movetypes?: string[];
  date?: string;
}

const dispatchVisibilityService = {
  getSummary: async (
    view: VisibilityView,
    filters: VisibilityFilters = {},
    signal?: AbortSignal,
  ): Promise<VisibilityRow[]> => {
    const res = await api.post<ListResponse<VisibilityRow>>(
      '/dispatch-visibility/summary',
      { view, ...filters },
      { signal },
    );
    return res.data.data;
  },
  getMoves: async (
    params: {
      view: VisibilityView;
      location_codes: number[];
      appt_date: string;
      bucket: VisibilityBucket;
      /** Orders-scope registry fieldnames to attach as extra columns. Sent as a real
       *  list in the POST body, not a comma-joined query param. */
      additional_fields?: string[];
    } & VisibilityFilters,
    signal?: AbortSignal,
  ): Promise<VisibilityMove[]> => {
    const res = await api.post<ListResponse<VisibilityMove>>('/dispatch-visibility/moves', params, { signal });
    return res.data.data;
  },
};

export default dispatchVisibilityService;
